












import {Component, Vue} from 'vue-property-decorator'

import Solution from '@/components/Solution.vue'
import {SolutionFile} from '@/models'

@Component({
  components: {
    Solution
  }
})
export default class Home extends Vue {
  private get allFiles(): SolutionFile {
    return this.$store.getters.allFiles
  }
}
